export default __webpack_public_path__ + "static/media/advanced-icon.310b5620.svg";